import { Button, Card, Form, Input, Radio, Table } from "antd";
import "../../pages/ClientSurvey/styles.css";
export default function AddClientSurvey({ form, handleClientSurveyFirstForm, loading, disabled }) {

    const columns = [
        {
            title: "S/N",
            dataIndex: "sn",
            key: "sn",
            align: "center",
            width: "2%",
            className: "custom-td"
        },
        {
            title: "Performance Criteria",
            dataIndex: "question",
            key: "question",
            align: "left",
            width: "60%",
            className: "custom-td"
        },
        {
            title: "Rating",
            dataIndex: "answer",
            key: "answer",
            align: "center",
            width: "30%",
            className: "custom-td"
        },
    ];

    const data = [
        {
            key: "1",
            sn: "1",
            question: "Were the services timely?",
            answer: (
                <Form.Item name="service_timely" rules={[{ required: true, message: "Please select an option" }]}>
                    <Radio.Group disabled={disabled} style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {[1, 2, 3, 4, 5].map(value => <Radio key={value} value={value}>{value}</Radio>)}
                    </Radio.Group>
                </Form.Item>
            ),
        },
        {
            key: "2",
            sn: "2",
            question: "Were Staff Responsive and Knowledgeable?",
            answer: (
                <Form.Item name="staff_responsive" rules={[{ required: true, message: "Please select an option" }]}>
                    <Radio.Group disabled={disabled} style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {[1, 2, 3, 4, 5].map(value => <Radio key={value} value={value}>{value}</Radio>)}
                    </Radio.Group>
                </Form.Item>
            ),
        },
        {
            key: "3",
            sn: "3",
            question: "Was the methodology, technology and analysis used of high quality and recommendations thorough and effective?",
            answer: (
                <Form.Item name="quality" rules={[{ required: true, message: "Please select an option" }]}>
                    <Radio.Group disabled={disabled} style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {[1, 2, 3, 4, 5].map(value => <Radio key={value} value={value}>{value}</Radio>)}
                    </Radio.Group>
                </Form.Item>
            ),
        },
        {
            key: "4",
            sn: "4",
            question: "Did you get Value for Money from the services?",
            answer: (
                <Form.Item name="value_for_money" rules={[{ required: true, message: "Please select an option" }]}>
                    <Radio.Group disabled={disabled} style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {[1, 2, 3, 4, 5].map(value => <Radio key={value} value={value}>{value}</Radio>)}
                    </Radio.Group>
                </Form.Item>
            ),
        },
        {
            key: "5",
            sn: "5",
            question: "Would you continue using our services and recommend them to a friend or colleague?",
            answer: (
                <Form.Item name="recommend" rules={[{ required: true, message: "Please select an option" }]}>
                    <Radio.Group disabled={disabled} style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {[1, 2, 3, 4, 5].map(value => <Radio key={value} value={value}>{value}</Radio>)}
                    </Radio.Group>
                </Form.Item>
            ),
        },
    ];

    return (
        <Form layout="vertical" onFinish={handleClientSurveyFirstForm} form={form}>
            <Card bordered={false}>
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    // bordered 
                    scroll={{ x: "max-content" }}
                    style={{ marginTop: 5 }}
                />
                <Form.Item
                    label="Additional Comment"
                    name="comment"
                    rules={[{ required: true, message: "Additional comments are required" }]}
                    style={{ marginTop: 20, display: "flex", flexDirection: "column" }}
                >
                    <Input.TextArea disabled={disabled} rows={3} style={{ resize: "none" }} />
                </Form.Item>
                <Form.Item name="recommendation_letter" label="Would you be able to give us a recommendation letter?"
                    rules={[{ required: true, message: "Additional comments are required" }]}
                >
                    <Radio.Group disabled={disabled}>
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                    </Radio.Group>
                </Form.Item>
                <div className="form-buttons align-right" style={{ marginTop: 20, textAlign: "left" }}>
                    <Button style={{ backgroundColor: "#5cb85c", color: "rgb(255 255 255)" }} htmlType="submit" loading={loading}>
                        Save
                    </Button>
                </div>
            </Card>
        </Form>
    );
}
